// extracted by mini-css-extract-plugin
export default {"container":"style_container__8Dqac","header":"style_header__DGBcs","content":"style_content__CWkAx"};